import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/common/TermsDisclaimer.css';

const TermsDisclaimer = () => (
  <p className="terms-disclaimer">
    By continuing, you agree to our{' '}
    <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">
      Terms of Service
    </Link>{' '}
    and acknowledge that you understand our{' '}
    <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </Link>.
  </p>
);

export default TermsDisclaimer;
